import type { InjectionKey } from "vue";
import type { AccessContextDto } from "./gfo_api/order_api";
declare global {
  function openPopup(key: string): void;
}
export const productInfoProviderKey: InjectionKey<ProductInfoProvider> = Symbol('ProductInfoProvider')

export class ProductInfoProvider {

    get integratedIn(): string {
        let hostname = window.location.hostname;
        if (hostname.includes("iway.ch")){
            return "iway";
        } else if (hostname.includes("sak-digital.ch")){
            return "sak";
        } else {
            return "dev"
        }
    }
    getInfoKeyByProductId(productId: number, accessContext: AccessContextDto|null): string | null {

        if ("dev" == this.integratedIn){
            const map: Record<number, string> = {
                1: "iway-produktdetails-interenet-popup"
            };
            return map[productId] ?? null;
        }
        if ("iway" == this.integratedIn){
            if (1 == productId && accessContext != null){
                // wenn checker durchgeführt wurde
                if (["adsl", "vdsl"].includes(accessContext.service_type ?? "")){
                    return "iway-produktdetails-DSL-internet-popup";
                } else if ("litex" == accessContext.service_provider){
                    return "iway-produktdetails-glasfaser-internet-litexchange-popup";
                } else {
                    return "iway-produktdetails-glasfaser-internet-popup";
                }
            }
            // Standard-Mapping
            const map: Record<number, string> = {
                1: "iway-produktdetails-internet-popup",
                3: "iway-produktdetails-Business-SLA-popup",
                6: "iway-produktdetails-tv-popup",
                20: "iway-produktdetails-telefonie-popup",
                30: "iway-produktdetails-mobile-popup",
            };
            
            return map[productId] ?? null;
        }
        return null;
    }
    hasInfoForProductId(productId: number, accessContext: AccessContextDto|null): boolean {

        const key = this.getInfoKeyByProductId(productId, accessContext);
        if (null == key){
            return false;
        }
        if (window.document.getElementById(key)){
            return true;
        } else {
            return false;
        }
    }

    openInfoForProductId(productId: number, accessContext: AccessContextDto|null){
        const key = this.getInfoKeyByProductId(productId, accessContext);
        if (null == key){
            return;
        }
        if ("dev" == this.integratedIn){
            // siehe declare ganz oben in dieser Datei
            if (typeof openPopup === "function") {
                openPopup(key);
            } else if (typeof (window as any).openPopup === "function") {
                (window as any).openPopup(key);
            } else {
                console.warn("openPopup ist nicht definiert");
            }
        } 
        if ("iway" == this.integratedIn){
            // siehe declare ganz oben in dieser Datei
            if (typeof openPopup === "function") {
                openPopup(key);
            } else if (typeof (window as any).openPopup === "function") {
                (window as any).openPopup(key);
            } else {
                console.warn("openPopup ist nicht definiert");
            }
        }

    }
}
